module.exports = __webpack_public_path__ + "img/type-9.3263c597.png";